import { Component, Input } from '@angular/core';
import { BackButtonComponent } from 'app/common/components/back-button/back-button.component';
import { ContentCardComponent } from 'app/common/components/content-card/content-card.component';
import { PostcardComponent } from './components/postcard/postcard.component';
import { AboutSchneidereiComponent } from './components/about-schneiderei/about-schneiderei.component';
import { ChipComponent } from 'app/common/components/chip/chip.component';
import { LinksComponent } from 'app/common/components/links/links.component';
import { FooterComponent } from 'app/footer/footer.component';

@Component({
  selector: 'app-schneidereipd',
  templateUrl: './schneidereipd.component.html',
  styleUrls: ['./schneidereipd.component.less'],
  imports: [
    ContentCardComponent,
    BackButtonComponent,
    PostcardComponent,
    AboutSchneidereiComponent,
    ChipComponent,
    LinksComponent,
    FooterComponent,
  ],
})
export class SchneidereipdComponent {
  Instagram = 'https://www.instagram.com/schneiderei.pd/';
  Web = 'https://schneidereipd.de';
  Color = '#A13333';

  chips = ['Angular', 'Design', 'Schneiderei', 'MailJs', 'Nginx'];
}